import { CanActivateViaAuthGuard } from './../bz-authentication/bz-can-activate-auth';
import { Routes } from '@angular/router';
import { UserJobsComponent } from './user-Jobs/user-jobs.component';
import { WaitsComponent } from './waits/waits.component';
import { AlertsComponent } from './alerts/alerts.component';
import {menus} from '../core/models/constants';

export const RoutesScheduler: Routes = [
    {
        path: menus.UserJobs.path,
        data: { title : menus.UserJobs.title },
        component : UserJobsComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: menus.Waits.path,
        data: { title : menus.Waits.title },
        component : WaitsComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: menus.Alerts.path,
        data: { title : menus.Alerts.title },
        component : AlertsComponent,
        canActivate: [CanActivateViaAuthGuard]
    }
];
